// Generated from the shared app source. Do not edit.
/* eslint-disable no-whitespace-before-property */
import {
  assertCivilDate,
  calculateAge,
  daysInMonth,
  isLeapYear,

} from './date.mjs';
import {
  analyzeName,



} from './name.mjs';
import {
  asKarmicDebt,
  METHODOLOGY_VERSION,

} from './methodology.mjs';
import {
  reduceToDigit,
  reduceWithMasters,
  sumDigits,

} from './reduction.mjs';









































































export function calculateNameProfile(
  fullName        ,
  options                     = {},
)              {
  const analysis = analyzeName(fullName, options);
  const destiny = calculateNameNumber(analysis);
  const soul = calculateNameNumber(analysis, 'vowel');
  const personality = calculateNameNumber(analysis, 'consonant');

  return {
    methodologyVersion: METHODOLOGY_VERSION,
    analysis,
    destiny: {
      ...destiny,
      karmicDebt: asKarmicDebt(destiny.raw),
    },
    soul,
    personality,
    karma: calculateKarmicNameAnalysis(analysis.frequencies),
  };
}

export function calculateDateProfile(
  birthDate           ,
  asOfDate           ,
)              {
  assertCivilDate(birthDate);
  assertCivilDate(asOfDate);
  const age = calculateAge(birthDate, asOfDate);
  const day = reduceWithMasters(birthDate.day);
  const month = reduceWithMasters(birthDate.month);
  const year = reduceWithMasters(birthDate.year);
  const originRaw = day.value + month.value + year.value;
  const originReduction = reduceWithMasters(originRaw);
  const origin = {
    raw: originRaw,
    value: originReduction.value,
    reduction: originReduction,
    karmicDebt: asKarmicDebt(originRaw),
  };

  const firstChallenge = calculateDigitNumber(Math.abs(day.value - month.value));
  const secondChallenge = calculateDigitNumber(Math.abs(year.value - day.value));
  const thirdChallenge = calculateDigitNumber(
    Math.abs(secondChallenge.value - firstChallenge.value),
  );
  const fourthChallenge = calculateDigitNumber(Math.abs(year.value - month.value));

  const firstPinnacle = reduceWithMasters(month.value + day.value).value;
  const secondPinnacle = reduceWithMasters(day.value + year.value).value;
  const thirdPinnacle = reduceWithMasters(firstPinnacle + secondPinnacle).value;
  const fourthPinnacle = reduceWithMasters(month.value + year.value).value;
  const originBaseDigit = reduceToDigit(origin.value).value;
  const firstEndsAt = 36 - originBaseDigit;
  const secondStartsAt = firstEndsAt + 1;
  const thirdStartsAt = secondStartsAt + 9;
  const fourthStartsAt = thirdStartsAt + 9;
  const pinnacles = [
    { number: firstPinnacle, startsAtAge: 0, endsAtAgeExclusive: secondStartsAt },
    {
      number: secondPinnacle,
      startsAtAge: secondStartsAt,
      endsAtAgeExclusive: thirdStartsAt,
    },
    {
      number: thirdPinnacle,
      startsAtAge: thirdStartsAt,
      endsAtAgeExclusive: fourthStartsAt,
    },
    { number: fourthPinnacle, startsAtAge: fourthStartsAt, endsAtAgeExclusive: null },
  ]         ;
  const currentPinnacle = (
    age < secondStartsAt ? 1 : age < thirdStartsAt ? 2 : age < fourthStartsAt ? 3 : 4
  )                 ;

  return {
    methodologyVersion: METHODOLOGY_VERSION,
    components: { day, month, year },
    birthNumber: birthDate.day,
    origin,
    challenges: [firstChallenge, secondChallenge, thirdChallenge, fourthChallenge],
    pinnacles,
    currentPinnacle,
    personalCycles: calculatePersonalCycles(birthDate, asOfDate),
  };
}

export function calculatePowerfulNumber(
  destiny        ,
  origin        ,
)                    {
  return calculateMasterNumber(destiny + origin);
}

function calculateNameNumber(
  analysis              ,
  kind                    ,
)                        {
  const partTotals = analysis.parts.map((_, partIndex) =>
    analysis.characters
      .filter(
        (character) => character.partIndex === partIndex && (!kind || character.kind === kind),
      )
      .reduce((total, character) => total + character.value, 0),
  );
  const partReductions = partTotals.map((total) => reduceWithMasters(total));
  const raw = partReductions.reduce((total, reduction) => total + reduction.value, 0);
  const reduction = reduceWithMasters(raw);

  return {
    raw,
    value: reduction.value,
    reduction,
    partTotals,
    partReductions,
  };
}

function calculateKarmicNameAnalysis(frequencies                   )                     {
  const missing = frequencies.flatMap((frequency, index) => (frequency === 0 ? [index + 1] : []));
  const highestFrequency = Math.max(0, ...frequencies);
  const lowerFrequencies = frequencies.filter((frequency) => frequency < highestFrequency);
  const comparisonFrequency =
    lowerFrequencies.length === 0 ? highestFrequency : Math.max(...lowerFrequencies);
  const hasExcess = highestFrequency - comparisonFrequency > 2;
  const excess = hasExcess
    ? frequencies.flatMap((frequency, index) =>
        frequency === highestFrequency ? [index + 1] : [],
      )
    : [];

  return {
    missing,
    excess,
    frequencies,
    highestFrequency,
    comparisonFrequency,
  };
}

function calculatePersonalCycles(
  birthDate           ,
  asOfDate           ,
)                 {
  const current = calculatePersonalCycleSnapshot(birthDate, asOfDate);
  const currentMonthLength = daysInMonth(asOfDate.year, asOfDate.month);
  const dailyNumbers = Array.from({ length: currentMonthLength }, (_, index) => {
    const day = index + 1;
    if (
      asOfDate.year === birthDate.year &&
      asOfDate.month === birthDate.month &&
      day < birthDate.day
    ) {
      return null;
    }
    return calculatePersonalCycleSnapshot(birthDate, {
      year: asOfDate.year,
      month: asOfDate.month,
      day,
    }).personalDay;
  });

  return {
    ...current,
    currentMonth: {
      year: asOfDate.year,
      month: asOfDate.month,
      currentDay: asOfDate.day,
      dailyNumbers,
    },
  };
}

function calculatePersonalCycleSnapshot(
  birthDate           ,
  asOfDate           ,
)                                       {
  const birthdayOccurred = hasBirthdayOccurred(birthDate, asOfDate);
  const cycleYear = birthdayOccurred ? asOfDate.year : asOfDate.year - 1;
  const personalYear = calculateMasterNumber(
    sumDigits(birthDate.day) + sumDigits(birthDate.month) + sumDigits(cycleYear),
  );
  const personalMonth = calculateMasterNumber(personalYear.value + asOfDate.month);
  const personalDay = calculateMasterNumber(personalMonth.value + asOfDate.day);

  return { cycleYear, personalYear, personalMonth, personalDay };
}

function hasBirthdayOccurred(
  birthDate           ,
  asOfDate           ,
)          {
  let birthdayMonth = birthDate.month;
  let birthdayDay = birthDate.day;

  if (birthDate.month === 2 && birthDate.day === 29 && !isLeapYear(asOfDate.year)) {
    birthdayMonth = 3;
    birthdayDay = 1;
  }

  return (
    asOfDate.month > birthdayMonth ||
    (asOfDate.month === birthdayMonth && asOfDate.day >= birthdayDay)
  );
}

function calculateMasterNumber(raw        )                    {
  const reduction = reduceWithMasters(raw);
  return { raw, value: reduction.value, reduction };
}

function calculateDigitNumber(raw        )                    {
  const reduction = reduceToDigit(raw);
  return { raw, value: reduction.value, reduction };
}
